// import * as page from '@/modules/page'
// const pageParams = page.tabParams.booth;

export const tabParams = {
  booth: ['settings', 'items', 'template', 'design', 'pickup', 'story', 'lineup', 'preview'],
  brand: [
    'settings',
    'design',
    'story',
    'sns',
    'order',
    'booth',
    'item',
    'preview',
  ],
  item: ['settings', 'images', 'sku', 'story', 'preview'],
};
